import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1bf5q9xdtj: FaireBrandEntity = {
  token: "b_1bf5q9xdtj",
  type: "brand",
  name: "LivyLu",
  avatarUrl:
    "https://cdn.faire.com/fastly/1be450cbf1a4599d0e6cf56f3e22a283bd62a45ef9795d52fce0bd1f7f267d3d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7c730f740cbeb64ef5fdd766ff70dcad74f35a6e44176cf3f6a6d02239e22ffa.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1be450cbf1a4599d0e6cf56f3e22a283bd62a45ef9795d52fce0bd1f7f267d3d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7c730f740cbeb64ef5fdd766ff70dcad74f35a6e44176cf3f6a6d02239e22ffa.jpeg",
  location: "Tulsa, OK, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 320,
  isTopShop: true,
  isInsider: true,
  description:
    "LivyLu is a lifestyle apparel brand specializing in vintage-inspired OFFICIALLY LICENSED collegiate and band graphic tees. Whether its for Game Day or Every Day, LivyLu has something for you.  Began as a mother/daughter venture in 2003 so our owner could stay home with her littles, LivyLu has grown to hold 20 college licenses and partnerships with several artists/bands!! We are constantly adding new partnerships and universities to our line, so check back often & stay tuned!\n\n*All of our Dolly Parton, Rolling Stones, The Beach Boys, Willie Nelson, The Who, and Pink Floyd products are OFFICIALLY LICENSED*\n\nWe do NOT encourage offering Pre-Orders!!!\n\n**PLEASE NOTE: We DO offer territory protection, and all orders are subject to cancellation should another retailer already be in their area.**",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:56.131Z",
    importedBy: "entity-db-cli",
  },
};
